module.exports = "/_next/static/images/award-AON-d3e5b0a83624c1ec7b631a91407721d2.png";